import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { isFirstChange } from '@devwareapps/devware-cap';

@Component({
  selector: 'dw-image-moved-to-cap',
  template: `
    <div [ngStyle]="containerStyle">
      <img [src]="src" [defaultSrc]="defaultSrc" [ngStyle]="imageStyle" [ngClass]="class">
    </div>
  `
})
export class DwImageComponent implements OnInit, OnChanges {
  @Input() src: string;
  @Input() defaultSrc: string;
  @Input() maxWidth: string;
  @Input() maxHeight: string;

  @Input() class: string;

  constructor() { }

  imageStyle: any;
  containerStyle: any;

  lastSrc: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (!isFirstChange(changes)) {
      this.setupImage();
    }
  }

  ngOnInit(): void {
    this.setupImage();
  }

  setupImage() {

    this.containerStyle = {
      'width': this.maxWidth,
      'height': this.maxHeight,
      'overflow': 'hidden'
    }

    this.imageStyle = {
      'width': this.maxWidth
    }
    if (!this.src) {
      return;
    }

    if (this.lastSrc && this.src == this.lastSrc) {
      return;
    }

    this.lastSrc = this.src;

    const image = new Image();
    image.src = this.src;

    image.onload = (e: any) => {
      const imageSize = this.getImageSize(e);

      if (!imageSize) {
        this.imageStyle = {
          'width': this.maxWidth
        }
        return;
      }
      
      if (imageSize.width > imageSize.height) {
        this.imageStyle = {
          'width': this.maxWidth
        }
      } else {
        this.imageStyle = {
          'height': this.maxHeight
        }
      }
    };
  }

  private getImageSize(imageLoadEvent: any): { height: number, width: number } {
    const image = imageLoadEvent.currentTarget;

    if (!image) {
      return null;
    }

    return { height: image.height, width: image.width };
  }

}
